import { defineComponent as _defineComponent } from 'vue'
import {
  HeadingDisplay,
  ContentDisplay,
  ButtonPrimary,
  ListDisplay,
  ConclusionStep
} from '@warrenbrasil/nebraska-web';
import { useRouter } from 'vue-router/composables';
import {
  trackEditedSuccessClose,
  trackEditedSuccessInvest
} from './track-events';


export default /*#__PURE__*/_defineComponent({
  __name: 'Edited',
  setup(__props) {

const router = useRouter();

function handleNextClick() {
  trackEditedSuccessInvest();
  router.push({
    name: 'wealthProductTransaction',
    params: { id: router.currentRoute.params.id }
  });
}

function handleCloseAction() {
  trackEditedSuccessClose();
  router.push({ name: 'wealth' });
}

return { __sfc: true,router, handleNextClick, handleCloseAction, HeadingDisplay, ContentDisplay, ButtonPrimary, ListDisplay, ConclusionStep }
}

})